'use client';

import { useEffect, useState } from 'react';
import { usePrivate } from '@/components/private/PrivateContext';
import { useWelcomeFlow } from './useWelcomeFlow';
import { WelcomeDialog } from '@/components/WelcomeDialog/WelcomeDialog';
import { SurveyDialog } from '@/components/SurveyDialog';
import { useSurveyFlow } from './useSurveyFlow';
import { getSessionStorageItem } from '@/lib/browserStorage';
import { RoleUserOrgAssociationDto } from '@/apiClient';

type TProps = {
  onFinishFlow: (organisations: RoleUserOrgAssociationDto[]) => void;
};
export function PostSignUpFlow({ onFinishFlow }: TProps) {
  const { userProfile, userOrganisations } = usePrivate();

  const {
    welcomeDialogOpen,
    isSubmittingWelcome,
    onClickBackWelcome,
    onSubmitWelcome,
  } = useWelcomeFlow();

  const {
    isSubmittingSurvey,
    surveyDialogOpen,
    onClickSkipQuestion,
    onClickSubmitSurvey,
  } = useSurveyFlow();

  const isEulaAccepted = userProfile?.isEulaAccepted;
  const hasSubmittedSurvey =
    userProfile?.surveyResponse?.surveyResponseEntityId;

  const surveySkipped =
    getSessionStorageItem<boolean>('surveySkipped') || false;
  const [flowDone, setFlowDone] = useState(false);

  useEffect(() => {
    if (!flowDone || !userOrganisations) return;

    onFinishFlow(userOrganisations!);
  }, [onFinishFlow, flowDone, userOrganisations]);

  if (!isEulaAccepted) {
    return (
      <WelcomeDialog
        loading={isSubmittingWelcome}
        open={welcomeDialogOpen}
        onClickBack={onClickBackWelcome}
        onSubmit={onSubmitWelcome}
      />
    );
  }

  if (isEulaAccepted && !hasSubmittedSurvey && !surveySkipped) {
    return (
      <SurveyDialog
        loading={isSubmittingSurvey}
        open={surveyDialogOpen}
        onClickSkip={() => {
          onClickSkipQuestion();
          setFlowDone(true);
        }}
        onClickSubmit={(checkedIds) => {
          onClickSubmitSurvey(checkedIds);
          setFlowDone(true);
        }}
      />
    );
  }

  return null;
}
